import actions from './financeActions'
import state from './financeState'
import getters from './financeGetters'
import mutations from './financeMutations'

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
